"use client";

import { createContext } from "react";

const SettingsContextProvider = ({ children, settings, assortment_menu, products }) => {

    const assortment_menus = assortment_menu?.menus ?? {};

    // add assortment_menus to settings.menus
    settings.menus = {
        ...settings.menus,
        ...assortment_menus,
    };

    return (
        <SettingsContext.Provider value={{ settings, assortment_menu, products }}>
            {children}
        </SettingsContext.Provider>
    );
};

export default SettingsContextProvider;
export const SettingsContext = createContext();

